import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import i18n from '../../i18n';

import styles from './Select.module.scss';

const Select = ({
    id,
    hideLabel,
    label,
    labelAll = 'Alla',
    options,
    defaultValue,
    name,
    showAll = true,
    modifier,
}) => {
    const [val, setVal] = useState(defaultValue || '');
    const classes = classNames(styles['Select'], {
        [styles[`Select--${modifier}`]]: !!modifier,
    });

    const labelClasses = classNames(styles['Select__Label'], {
        'sr-only': hideLabel,
    });

    return (
        <div className={classes}>
            {label && (
                <label htmlFor={id} className={labelClasses}>
                    {label}
                </label>
            )}
            <div className={styles['Select__SelectWrap']}>
                <select
                    className={styles['Select__Select']}
                    onChange={(e) => setVal(e.target.value)}
                    value={val}
                    name={name}
                    id={id}
                >
                    {showAll && (
                        <option key={`${id}-show-all`} value="">
                            {labelAll}
                        </option>
                    )}
                    {options.map((item, i) => {
                        return (
                            <option value={item.value} key={i}>
                                {item.label}
                            </option>
                        );
                    })}
                </select>
            </div>
        </div>
    );
};

Select.propTypes = {};

Select.defaultProps = {
    options: [],
};

export default Select;
